var map = {
	"./Coinsdataflow.jpeg": 238,
	"./Cointelegraph.jpeg": 239,
	"./Concerto-Logo.png": 240,
	"./EY.jpeg": 241,
	"./FinancialIT.jpeg": 242,
	"./IDS Fintech Logo/fintech logo/250-100px/fintech-logo---blue-type.png": 243,
	"./IDS Fintech Logo/fintech logo/250-100px/fintech-logo---white-type.png": 244,
	"./IDS Fintech Logo/fintech logo/800 verticl version/fintech-logo-blue-version.png": 245,
	"./IDS Fintech Logo/fintech logo/800 verticl version/fintech-logo-white-version.png": 246,
	"./IDS Fintech Logo/fintech logo/high Res horizontal/landscape-white-text.png": 247,
	"./ManageEngine.png": 248,
	"./NIIT.jpeg": 249,
	"./Neosoft.jpeg": 250,
	"./NewsAffinity.jpeg": 251,
	"./Payoneer.jpeg": 252,
	"./TEMENOS.png": 253,
	"./Vaccumlabs.jpg": 254,
	"./Watermelon.jpeg": 255,
	"./abaka.jpg": 256,
	"./africa.jpeg": 257,
	"./ambidextr.jpeg": 258,
	"./appway.png": 259,
	"./arabnet.jpeg": 260,
	"./aroundb.png": 261,
	"./avaya.png": 262,
	"./azentio.jpg": 263,
	"./backbase.jpeg": 264,
	"./backbase.png": 265,
	"./bankingcio.jpeg": 266,
	"./bankserv.jpg": 267,
	"./bc.jpeg": 268,
	"./beingcrypto.png": 269,
	"./bigdata.jpeg": 270,
	"./blocksocial.jpeg": 271,
	"./caia.jpeg": 272,
	"./cibe.jpeg": 273,
	"./coforge.jpg": 274,
	"./coinpedia.jpeg": 275,
	"./coinquora.png": 276,
	"./coinrepublic.png": 277,
	"./coinsflare.jpeg": 278,
	"./comarch.jpeg": 279,
	"./comforte_logo.png": 280,
	"./comviva.png": 281,
	"./confluent.jpg": 282,
	"./conrad.png": 283,
	"./consdata.jpeg": 284,
	"./creatio.png": 285,
	"./cryptoSaudi.png": 286,
	"./cryptonewz.jpeg": 287,
	"./daon.jpg": 288,
	"./darktrace.png": 289,
	"./difc.jpg": 290,
	"./difc.png": 291,
	"./edb.png": 292,
	"./expo.jpeg": 293,
	"./expo2020.png": 294,
	"./faloos.jpg": 295,
	"./findbiometrics.jpeg": 296,
	"./fintech.jpeg": 297,
	"./fintechfinance.jpeg": 298,
	"./fintechfutures.jpeg": 299,
	"./fintechgalaxy.jpeg": 300,
	"./fintechgalaxy.jpg": 301,
	"./fintechpower.jpeg": 302,
	"./fintechtimes.jpeg": 303,
	"./fireeye.png": 304,
	"./freshworks.png": 305,
	"./fss.png": 306,
	"./hcl.jpg": 307,
	"./hyperpay.jpeg": 308,
	"./ibm.jpeg": 309,
	"./ids.png": 310,
	"./ie.jpg": 311,
	"./igologic.jpg": 312,
	"./iib.jpeg": 313,
	"./infobip.jpeg": 314,
	"./infosys.jpg": 315,
	"./infrasoft.png": 316,
	"./investera.jpeg": 317,
	"./kissflow.jpg": 318,
	"./kitamo.jpeg": 319,
	"./maxut.png": 320,
	"./menafintech.jpeg": 321,
	"./microsoft.png": 322,
	"./mobileidworld.jpeg": 323,
	"./neosoft.png": 324,
	"./network.jpg": 325,
	"./newgen.png": 326,
	"./onespan.jpeg": 327,
	"./onespan.jpg": 328,
	"./openfactor.png": 329,
	"./oracle.jpeg": 330,
	"./oxford.png": 331,
	"./paypers.jpg": 332,
	"./piotech.png": 333,
	"./privatebanking.jpeg": 334,
	"./pwc.jpeg": 335,
	"./pwc.jpg": 336,
	"./rakbank.png": 337,
	"./recorded.png": 338,
	"./regtech.png": 339,
	"./scventure.jpg": 340,
	"./sinofy.png": 341,
	"./skiply.png": 342,
	"./smart.png": 343,
	"./smartmessage.png": 344,
	"./smartstream.jpeg": 345,
	"./smartstream.png": 346,
	"./tata.jpeg": 347,
	"./tcs.jpg": 348,
	"./telco.jpeg": 349,
	"./temenos.jpg": 350,
	"./threatLocker.jpg": 351,
	"./tripwire.jpeg": 352,
	"./truebanking.jpeg": 353,
	"./turbonomic.png": 354,
	"./ufg.png": 355,
	"./unlock.png": 356,
	"./yethi.png": 357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;